import { HtmlDocType } from "./htmlDocType";

export class HtmlDocumentVersion {

  constructor(
    private id: number, 
    private documentId: number, 
    private documentType: HtmlDocType,
    private createdByUserId: number, 
    private htmlContent: string, 
    private createdAt: string
  ) {}

  getId(): number { return this.id; }
  getDocumentId(): number { return this.documentId; }
  getDocumentType(): HtmlDocType { return this.documentType; }
  getCreatedByUserId(): number { return this.createdByUserId; }
  getHtmlContent(): string { return this.htmlContent; }
  getCreatedAt(): string { return this.createdAt; }

  static fromJson(json: any): HtmlDocumentVersion {
    return new HtmlDocumentVersion(json.id, json.documentId, json.documentType, json.createdByUserId, json.htmlContent, json.createdAt);
  }
}